import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConditionalMatIconModule } from '../conditional-mat-icon/conditional-mat-icon.module';
import { SubToolbarComponent } from './sub-toolbar.component';
import { AppModule } from '@caslink/device-client/ng-app/module';

@NgModule({
    declarations: [SubToolbarComponent],
    imports: [
        CommonModule,
        ConditionalMatIconModule,
        MatIconModule,
        MatTooltipModule,
        AppModule,
    ],
    exports: [SubToolbarComponent]
})
export class SubToolbarModule {
}
